export default __webpack_public_path__ + "fonts/SF-Pro-Text-Regular.woff2";